export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PHONE_DISPLAY = "0729 325 082";
export const PHONE_TEL = "tel:0729325082";
export const WHATSAPP_URL =
  "https://wa.me/40729325082?text=Buna%20ziua!%20Doresc%20o%20oferta%20pentru%20foraj%20de%20put.";

export const DEFAULT_PRICING = {
  base_rate_per_meter: 190,
  min_depth: 10,
  max_depth: 150,
  step: 5,
  casings: [
    { id: "d125", label: "Ø125 mm", detail: "inclusă în preț", extra_per_meter: 0 },
    { id: "d140", label: "Ø140 mm", detail: "+15 lei / metru", extra_per_meter: 15 },
    { id: "d160", label: "Ø160 mm", detail: "+30 lei / metru", extra_per_meter: 30 },
  ],
  localities: [
    { name: "București – Sector 1", group: "București", transport: 0 },
    { name: "București – Sector 2", group: "București", transport: 0 },
    { name: "București – Sector 3", group: "București", transport: 0 },
    { name: "București – Sector 4", group: "București", transport: 0 },
    { name: "București – Sector 5", group: "București", transport: 0 },
    { name: "București – Sector 6", group: "București", transport: 0 },
    { name: "Otopeni", group: "Ilfov", transport: 100 },
    { name: "Voluntari", group: "Ilfov", transport: 100 },
    { name: "Pantelimon", group: "Ilfov", transport: 100 },
    { name: "Popești-Leordeni", group: "Ilfov", transport: 100 },
    { name: "Tunari", group: "Ilfov", transport: 100 },
    { name: "Ștefăneștii de Jos", group: "Ilfov", transport: 100 },
    { name: "Jilava", group: "Ilfov", transport: 100 },
    { name: "Chiajna", group: "Ilfov", transport: 150 },
    { name: "Mogoșoaia", group: "Ilfov", transport: 150 },
    { name: "Corbeanca", group: "Ilfov", transport: 150 },
    { name: "Găneasa", group: "Ilfov", transport: 150 },
    { name: "Afumați", group: "Ilfov", transport: 150 },
    { name: "Bragadiru", group: "Ilfov", transport: 150 },
    { name: "Domnești", group: "Ilfov", transport: 150 },
    { name: "Clinceni", group: "Ilfov", transport: 150 },
    { name: "Măgurele", group: "Ilfov", transport: 150 },
    { name: "Buftea", group: "Ilfov", transport: 150 },
    { name: "1 Decembrie", group: "Ilfov", transport: 150 },
    { name: "Vidra", group: "Ilfov", transport: 150 },
    { name: "Cernica", group: "Ilfov", transport: 150 },
    { name: "Glina", group: "Ilfov", transport: 150 },
    { name: "Ciorogârla", group: "Ilfov", transport: 200 },
    { name: "Balotești", group: "Ilfov", transport: 200 },
    { name: "Dascălu", group: "Ilfov", transport: 200 },
    { name: "Petrăchioaia", group: "Ilfov", transport: 200 },
    { name: "Berceni", group: "Ilfov", transport: 200 },
    { name: "Sintești", group: "Ilfov", transport: 200 },
    { name: "Moara Vlăsiei", group: "Ilfov", transport: 250 },
    { name: "Snagov", group: "Ilfov", transport: 250 },
    { name: "Periș", group: "Ilfov", transport: 250 },
    { name: "Nuci", group: "Ilfov", transport: 250 },
    { name: "Grădina", group: "Ilfov", transport: 250 },
    { name: "Copăceni", group: "Ilfov", transport: 250 },
  ],
};

export const formatLei = (n) => Math.round(n).toLocaleString("ro-RO");

export const slugifyRo = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

export const localitySlug = (name) => slugifyRo(name);

export const findLocalityBySlug = (slug) =>
  DEFAULT_PRICING.localities.find((l) => slugifyRo(l.name) === slug) || null;
